const MAX_PARTIAL_RETROFIT_EQUIVALENT = 1;
export const ENVELOPE_COMPONENT_LIST = [
    { key: "FULL", partialRetrofitEquivalent: 1 },
    { key: "TOP_FLOOR_CEILING_OR_ROOF", partialRetrofitEquivalent: 0.33 },
    { key: "BASEMENT_CEILING", partialRetrofitEquivalent: 0.32 },
    { key: "FACADE", partialRetrofitEquivalent: 0.23 },
    { key: "WINDOWS", partialRetrofitEquivalent: 0.12 },
];
export const FULL_RETROFIT_COMPONENT_KEY = "FULL";
export const ENVELOPE_COMPONENT_KEY_LIST = ENVELOPE_COMPONENT_LIST.map((component) => component.key);
export const PARTIAL_RETROFIT_EQUIVALENT_BY_COMPONENT = Object.fromEntries(ENVELOPE_COMPONENT_LIST.map((component) => [component.key, component.partialRetrofitEquivalent]));
export const isEnvelopeComponentKey = (value) => typeof value === "string" && ENVELOPE_COMPONENT_KEY_LIST.includes(value);
export function computePartialRetrofitEquivalent(componentList) {
    const sum = componentList.reduce((total, component) => total + PARTIAL_RETROFIT_EQUIVALENT_BY_COMPONENT[component], 0);
    return Math.min(MAX_PARTIAL_RETROFIT_EQUIVALENT, sum);
}
